__turbopack_context__.v({
  "buttonLink": "DFeSKa_buttonLink",
  "container": "DFeSKa_container",
  "content": "DFeSKa_content",
  "img": "DFeSKa_img",
  "title": "DFeSKa_title",
});
